import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import '../assets/sass/creative.scss';

const schemaOrgLocalBusiness = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'HomeAndConstructionBusiness',
  name: 'Wasescha Maler',
  description:
    'Malerbetrieb in Savognin, Val Surses – Malen, Spritzen, Tapezieren, Fassaden, Mineralverputze, Dekorative Techniken, Schimmelsanierung. Kostenlose Offerte.',
  url: 'https://www.waseschamaler.ch',
  telephone: '+41 81 558 98 99',
  email: 'info@waseschamaler.ch',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Gravas 6',
    addressLocality: 'Cunter',
    postalCode: '7452',
    addressRegion: 'GR',
    addressCountry: 'CH',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 46.607,
    longitude: 9.564,
  },
  areaServed: {
    '@type': 'GeoCircle',
    geoMidpoint: { '@type': 'GeoCoordinates', latitude: 46.607, longitude: 9.564 },
    geoRadius: '50000',
  },
  priceRange: 'CHF',
  image: 'https://www.waseschamaler.ch/Logo-WM.png',
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '07:00',
    closes: '17:30',
  },
  sameAs: [],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Malerarbeiten',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Malen & Spritzen' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Tapezieren' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Fassadenarbeiten' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Mineralverputze' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Dekorative Techniken' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Schimmelpilzsanierung' } },
    ],
  },
});

class Layout extends Component {
  render() {
    const { children } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={`${data.site.siteMetadata.title} – Maler in Savognin, Val Surses, Graubünden`}
              meta={[
                {
                  name: 'description',
                  content:
                    'Maler Wasescha in Savognin, Val Surses – Malen, Spritzen, Tapezieren, Fassaden, Mineralverputze, Dekorative Techniken, Schimmelsanierung. Kostenlose Offerte unter +41 81 558 98 99',
                },
                {
                  name: 'keywords',
                  content:
                    'Maler Graubünden, Maler Savognin, Maler Surses, Maler Val Surses, Maler Cunter, Maler Tiefencastel, Malerbetrieb, Malen Spritzen, Tapezieren, Fassaden, Mineralverputze, Dekorative Techniken, Schimmelpilzsanierung, Oberhalbstein, Graubünden Maler',
                },
                { name: 'author', content: 'Ricardo Wasescha' },
                { name: 'robots', content: 'index, follow' },
                { name: 'geo.region', content: 'CH-GR' },
                { name: 'geo.placename', content: 'Savognin' },
                { name: 'geo.position', content: '46.607;9.564' },
                { name: 'ICBM', content: '46.607, 9.564' },
                // Open Graph
                { property: 'og:title', content: 'Wasescha Maler – Maler in Savognin, Val Surses, Graubünden' },
                {
                  property: 'og:description',
                  content:
                    'Malerbetrieb in Savognin, Val Surses, Graubünden. Malen, Spritzen, Tapezieren, Fassaden, Mineralverputze, Schimmelsanierung und dekorative Techniken.',
                },
                { property: 'og:type', content: 'website' },
                { property: 'og:url', content: 'https://www.waseschamaler.ch' },
                { property: 'og:image', content: 'https://www.waseschamaler.ch/Logo-WM.png' },
                { property: 'og:locale', content: 'de_CH' },
                { property: 'og:site_name', content: 'Wasescha Maler' },
                // Twitter
                { name: 'twitter:card', content: 'summary_large_image' },
                {
                  name: 'twitter:title',
                  content: 'Wasescha Maler – Maler in Savognin, Val Surses, Graubünden',
                },
                {
                  name: 'twitter:description',
                  content:
                    'Malerbetrieb in Savognin, Val Surses, Graubünden. Malen, Spritzen, Tapezieren, Fassaden & mehr. Kontakt: +41 81 558 98 99',
                },
                { name: 'twitter:image', content: 'https://www.waseschamaler.ch/Logo-WM.png' },
                // Canonical handled via link below
              ]}
            >
              <html lang="de" />
              <script type="application/ld+json">{schemaOrgLocalBusiness}</script>
              <link rel="canonical" href="https://www.waseschamaler.ch/" />
              <link rel="stylesheet" href="/fonts/merriweather.css" />
            </Helmet>
             <main id="main" className={'page-top'}>{children}</main>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;